import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCohortProfileQuery } from '@verantos-dev/data-access-cohorts';

export const useCohortMetadata = () => {
  const intl = useIntl();
  const { projectId, cohortId } = useParams();

  const { data: cohort } = useCohortProfileQuery({
    projectId: projectId || '',
    cohortId: cohortId || '',
  });

  const cohortOwner = useMemo(() => {
    if (!cohort) return undefined;
    const first = cohort.createdByFirstName;
    const last = cohort.createdByLastName;
    if (!first && !last) return undefined;
    return `${first} ${last}`.trim();
  }, [cohort]);

  const cohortLastModified = useMemo(() => {
    const transactionDate = cohort?.modifiedByTransactionDate;
    if (!transactionDate) return undefined;
    const date = intl.formatDate(transactionDate, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
    const time = intl.formatTime(transactionDate, { hour: 'numeric', minute: '2-digit' });
    return `${date} | ${time}`;
  }, [cohort, intl]);

  return { cohortOwner, cohortLastModified };
};
